export default {
  // not up to date
    english: {
        "Erreur d'application. Veuillez rafraîchir la page où réessayer dans une heure. Si l'erreur persiste, veuillez nous contacter par téléphone" : 'Application error. Reload the page or try again later. If the error stays, please contact us ',
        // Header
        'Retour à la page web' : 'Back to the homepage',
        // Card verification
        'Prise de rendez-vous' : 'Make an appointment',
        'Validation de la carte SIVEC' : 'SIVEC card validation',
        'Réessayer' : 'Try again',
        'Numéro de carte invalide. Veuillez nous contacter par téléphone' : 'Invalid card number. Try to call',
        'Annuler' : 'Cancel',
        'Vérifier le numéro' : 'Validate',
        'Numéro de la carte SIVEC' : 'SIVEC card number',
        // Plate verification
        'Type de votre véhicule' : 'Type of vehicle',
        'Numéro de plaque' : 'Number Plate',
        // Vehicle selection
        'Voiture' : 'Car',
        'Voiture avec remorque' : 'Car with trailer',
        'Camionnette' : 'Van',
        'Camionnette avec remorque' : 'Van with trailer',
        // Date Time Selection
        'à' : 'at',
        'Rendez-vous disponibles' : 'Available appointments',
        "Veuillez entrer la date et l'heure de votre choix. Votre demande sera vérifiée après son envoi et, le cas échéant, confirmée par courrier électronique." : 'Choose a date and a time. You will receive a digital confirmation once submitted',
        // Material selection
        'Restrictions des materiaux par visite' : 'Material capactiy per visit',
        'Vous pouvez télécharger des images ici si vous le souhaitez… ' : 'You can upload pictures here...',
        'télécharger' : 'upload',
        // Contact Details
        'Données de contact' : 'Contact Information',
        'Votre numéro de téléphone et votre adresse mail seront utilisés pour la confirmation et comme moyen de contact pour votre réservation.' : 'We use your email address or phone number to confirm your appointment',
        'Nr. Télephone' : 'Phone number',
        'Adresse e-mail' : 'Email address',
        // Conditions
        'Conditions de la visite' : 'Conditions',
        'Règles de comportement' : 'Behaviour rules',
        "J'ai lu et j'accepte les" : 'I read and I agree to the',
        'conditions générales' : 'terms and conditions',
        // Summary
        'Votre demande de réservation' : 'Your appointment details',
        'Statu' : 'Status',
        'approuvée' : 'validated',
        'Nr. de la carte SIVEC' : 'SIVEC card number',
        'Votre véhicule' : 'Your vehicle',
        'Plate number required:' : 'Plate number required:',
        'Vehicle required:' : 'Vehicle required:',
        "We need this so we can verify it's you" : "We need this so we can verify it's you",
        'We need this so we can suggest a drop off date' : 'We need this so we can suggest a drop off date',
        'Nr. de votre plaquette' : 'Plate number',
        'Type de véhicule' : 'Vehicle type',
        'Votre matériel à remettre' : 'Material you want to drop off',
        'Materiaux required:' : 'Material required',
        'Please select at least 1 material you want to drop off' : 'Please select at least 1 material you want to drop off',
        'Contact' : 'Contact',
        'Number / Email required:' : 'Number / Email required:',
        'We need this to confirm your appointment' : 'We need this to confirm your appointment',
        'Nr. de Téléphone' : 'Phone number',
        'Date et heure sollicitées' : 'Selected date and time',
        'Envoyer la demande' : 'Submit',
        "Veuillez sélectionner la date et l'heure de votre choix" : 'Please select a date and time'
    }
};
